import * as React from 'react';
import { MetroLineSectionProps } from 'app/components/metro-line/types';
import styles from './metro-line-section.scss';
import { getSectionId } from 'app/components/metro-line/helpers';

export class MetroLineSection<SectionType> extends React.PureComponent<MetroLineSectionProps<SectionType> & React.PropsWithChildren> {
  public render() {
    const { shouldRenderSection, getRef, children, section, sectionType, hasBigStickyHeader = false } = this.props;
    return <div ref={getRef(sectionType)} className={shouldRenderSection(section, sectionType) ? styles.section : styles.hiddenSection}>
      <div id={getSectionId(sectionType)} className={hasBigStickyHeader ? styles.bigStickyHeaderAnchor : styles.anchor} />
      {children}
    </div>;
  }
}
